<script>
  import { Col } from 'element-ui'
  export default {
    name:'ElCol',
    extends:Col
  }
</script>
